import React, { useState, useEffect, useRef } from 'react';
import { bindActionCreators } from "redux";
import * as actions_station from "../../home-page/home-page-store/HomePageAction";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import '../navbar.scss';
import dropdownIcon from '../../../assets/images/dropdown.svg';
import { useHistory } from 'react-router-dom';
import strings from "../../../resources/strings.json"

const AdminMenu = (props) => {


    const menuOptions = [{title:"MyTime", submenu: props.navMenu.mytime},{title: "Mando", submenu: props.navMenu.mando}, {title: "VTO", submenu: props.navMenu.vto || []},
        // {title: "Overtime", submenu: props.navMenu.overtime || []}
        ];

    const [currentMenu, setCurrentMenu] = useState([]);
    const [hoveredMenu, setHoveredMenu] = useState(null);
    const hoveredMenuRef = useRef(null);
    const history = useHistory();
    const menuRef = useRef(null);
    const {
        setisAdminMenuOpen,
        isAdminMenuOpen
    } = props;

    const handleClickMenu = (e) => {
        setCurrentMenu('')
        if (history.location.pathname !== e.currentTarget.id) {
            props.action_station.navTreeReset();
        }
    }

    const handleClick = (e) => {
        setCurrentMenu(e.currentTarget.id)
    }

    const hasPermission = (item) => {
        if (props.additionalAccess) return true;
        return item.permission && item.permission.includes(localStorage.getItem(strings.adminType));
    }

    const getHalfMenu = (menu) => {
        const filteredItems = menu.filter(hasPermission);
        let firstHalf = [...filteredItems.slice(0,4)];
        let secondHalf = [...filteredItems.slice(4)];
        return [firstHalf,secondHalf];
    }

    useEffect(()=> {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setCurrentMenu('')
            }
        }

        document.addEventListener('mousedown', handleClickOutside);

        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        }

    },[])

    return (
        <>
       <div className='admin-container' 

         onMouseLeave={() => {
            setHoveredMenu(null);
            hoveredMenuRef.current = null;
            if (window.adminMenuTimeout) clearTimeout(window.adminMenuTimeout);
         }}
        
            attr={`${isAdminMenuOpen}`} ref={menuRef}
         >
            <ul className='admin-menu-title'>
                <li style={{display:'flex', marginLeft:10, alignItems: 'strech', justifyContent: 'flex-start'}}>
                    <p style={{marginLeft: 14, marginRight: 0, opacity: 0.9,}}>Admin Menu</p><span style={{marginLeft: 20, marginRight: 25, borderWidth: 0.5, borderStyle: 'solid', marginTop: 5, marginBottom: 5, borderColor: 'white', opacity: 0.5}}></span>
                </li>
                {isAdminMenuOpen&&
                menuOptions.filter(menuItem=> {
                    const adminType = localStorage.getItem(strings.adminType);
                    
                    if (menuItem.title === 'MyTime') {
                        // MyTime is shown to all admin users
                        return true;
                    } else if (menuItem.title === 'Mando') {
                        // Show Mando for users with mando_admin, ot_read_admin, mm_admin, mm_read_admin, or super roles
                        return adminType === strings.mando_admin || 
                               adminType === strings.ot_read_admin || 
                               adminType === strings.mm_admin ||
                               adminType === strings.mm_read_admin || 
                               adminType === strings.super;
                    } else if (menuItem.title === 'VTO') {
                        // Show VTO only if enabled AND user has mando_admin, ot_read_admin, mm_admin, mm_read_admin, or super roles
                        return props.vtoEnabled && (
                            adminType === strings.mando_admin || 
                            adminType === strings.ot_read_admin || 
                            adminType === strings.mm_admin ||
                            adminType === strings.mm_read_admin || 
                            adminType === strings.super
                        );
                    } else if (menuItem.title === 'Overtime') {
                        return props.otEnabled && (
                            adminType === strings.mm_admin || 
                            adminType === strings.mytime_admin || 
                            adminType === strings.super
                        );
                    }
                    
                    return false;
                }).map((menuItem,i)=>{
                    return (<li key={(menuItem.title+i).toString()}
                        className='admin-menu-item'  style={{boxShadow: menuItem.title==currentMenu&&"0 0 5px rgba(0,0,0,.05), 2px 2px 5px rgba(0,0,0,.1)", borderRadius: '10px 10px 0px 0px' }} onClick={(e)=>handleClick(e)} id={menuItem.title} data={menuItem.title} 
                        onMouseEnter={()=>{
                            setHoveredMenu(menuItem.title);
                            hoveredMenuRef.current = menuItem.title;
                            if (menuItem.title !== currentMenu) {
                                if (window.adminMenuTimeout) clearTimeout(window.adminMenuTimeout);
                                window.adminMenuTimeout = setTimeout(() => {
                                    if (hoveredMenuRef.current === menuItem.title) {
                                        setCurrentMenu(menuItem.title);
                                    }
                                }, 200);
                            } else {
                                if (window.adminMenuTimeout) clearTimeout(window.adminMenuTimeout);
                            }
                        }}
                >
                   <p>{menuItem.title}</p>
                    <ul className='submenu' attr={`${menuItem.submenu.length > 5}`} style={{display: menuItem.title==currentMenu&&"flex",borderRadius: '0px 0px 10px 10px', boxShadow: "0 0 5px rgba(0,0,0,.05), 2px 2px 5px rgba(0,0,0,.1)"  }}>
                        {menuItem.submenu.length <=5 ?
                        menuItem.submenu.filter(hasPermission).map(item=>{
                            return <NavLink key={(item.title).toString()} path={item.nav} id={item.nav} data={item.title} className="submenu-item" onClick={(e)=>handleClickMenu(e)} 
                            to={item.nav}>{item.title}</NavLink>
                        })
                        :
                        getHalfMenu(menuItem.submenu).map((halfMenu, idx)=>{
                            if (halfMenu.length === 0) return null;
                            return <ul key={halfMenu[0].title} style={{display:'flex', }} className='halfmenu'>
                            {halfMenu.map(item=> {
                                return <NavLink key={(item.title).toString()} path={item.nav} id={item.nav} data={item.title} className="submenu-item" onClick={(e)=>handleClickMenu(e)}
                                to={item.nav}>{item.title}</NavLink>
                            })} 
                            </ul>
                        })
                    }
                    </ul>
                </li>)
                })}
            </ul>
        </div>
      </>
    )
}

const mapStateToProps = (state) => ({
    navTree: state.HomePageReducer.navTree,
    isAdminMenuOpen: state.HomePageReducer.isAdminMenuOpen, 
    additionalAccess: state.HomePageReducer.additionalAccess,
    vtoEnabled: state.HomePageReducer.vtoEnabled,
    otEnabled: state.HomePageReducer.otEnabled,
    additionalProperties: state.HomePageReducer.additionalProperties
})

const mapDispatchToProps = (dispatch) => ({
    action_station: bindActionCreators({...actions_station}, dispatch),
    setisAdminMenuOpen: (params) =>
        dispatch({ type: "SET_ADMIN_MENU_OPEN", params:params }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminMenu);
